/**
 * Directive để sanitize nội dung HTML trước khi render
 * Ngăn chặn XSS Stored
 * Created by: tbngoc - 04.03.2025
 */

import DOMPurify from 'dompurify';

/**
 * Cấu hình DOMPurify với các option an toàn
 */
const sanitizeConfig = {
  ALLOWED_TAGS: [
    // Các thẻ cơ bản
    'a', 'b', 'br', 'div', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'i', 'li', 'ol', 'p', 'span', 'strong', 'u', 'ul',
    // Các thẻ bảng
    'table', 'thead', 'tbody', 'tr', 'th', 'td',
    // Các thẻ inline
    'code', 'pre', 'blockquote', 'hr'
  ],
  ALLOWED_ATTR: [
    // Các thuộc tính cơ bản và cho phép data-* để hỗ trợ custom data attributes
    'class', 'id', 'href', 'target', 'rel', 'src', 'alt', 'title', 'style', 'data-*'
  ],
  ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|file):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
  ADD_ATTR: ['target'], // Cho phép thuộc tính target để hỗ trợ mở link trong tab mới
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input', 'button'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'style', 'rel'],
  ALLOW_DATA_ATTR: false, // Tắt data-* attributes mặc định, chỉ cho phép qua ALLOWED_ATTR
  USE_PROFILES: { html: true },
  SANITIZE_DOM: true,
  KEEP_CONTENT: true
};

/**
 * Directive v-safe-html: Thay thế cho v-html với khả năng loại bỏ XSS
 */
export const vSafeHtml = {
  beforeMount(el, binding) {
    if (binding.value) {
      el.innerHTML = DOMPurify.sanitize(binding.value, sanitizeConfig);
    }
  },
  updated(el, binding) {
    if (binding.value) {
      el.innerHTML = DOMPurify.sanitize(binding.value, sanitizeConfig);
    }
  }
};

/**
 * Utility function để sanitize HTML trực tiếp
 * Có thể sử dụng trong computed, methods hoặc các context khác
 * 
 * @param {String} html - HTML cần sanitize
 * @param {Object} config - Cấu hình tùy chỉnh (optional, mặc định dùng sanitizeConfig)
 * @returns {String} HTML đã được sanitize
 */
export const sanitizeHtml = (html, config = sanitizeConfig) => {
  return DOMPurify.sanitize(html, config);
};

export default {
  vSafeHtml,
  sanitizeHtml
};
